import $ from 'jquery';
import 'slick-carousel';

export function newsGallery() {
  const newsElements = document.querySelectorAll('.news-single');
  const loadMoreButton = document.querySelector('.load-more-button');

  let hiddenElements = [...newsElements].filter((element, index) => {
    if (index > 2) {
      return element;
    }
  });

  hiddenElements.forEach(element => {
    element.classList.add('over-limit');
  });

  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', () => {
      hiddenElements.forEach(element => element.classList.toggle('over-limit'));
      loadMoreButton.classList.toggle('show');
    });
  }

  window.addEventListener('resize', setArrowsPosition);
  window.addEventListener('DOMContentLoaded', setArrowsPosition);

  function setArrowsPosition() {
    const carouselArrows = document.querySelectorAll('.news-gallery-container .slick-custom-arrow');
    const firstCarouselImage = document.querySelector('.news-wrapper .news-single-image');

    if (firstCarouselImage && carouselArrows) {
      setTimeout(() => {
        const firstImageHeight = firstCarouselImage.clientHeight;
        carouselArrows.forEach(arrow => {
          arrow.style.top = `${firstImageHeight / 2}px`;
        });
      }, 100);
    }
  }

  ////// Slick initialize
  $('.news-wrapper').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: $('.slick-next-arrow'),
    prevArrow: $('.slick-prev-arrow'),
    responsive: [
      {
        breakpoint: 767,
        settings: "unslick"
      }
    ]
  });
}


// WEBPACK FOOTER //
// ./src/js/news-gallery.js